// extracted by mini-css-extract-plugin
module.exports = {"search":"Search_search__3jZSk","content":"Search_content__1YS79","title":"Search_title__15ZdR","pag":"Search_pag__2rmwH"};